import React from 'react';

const TONE = {
    primary: 'bg-primary-50 text-primary-700 ring-primary-700/15 border-primary-200/60',
    success: 'bg-success-50 text-success-700 ring-success-700/15 border-success-200/60',
    warning: 'bg-warning-50 text-warning-700 ring-warning-700/15 border-warning-200/60',
    danger:  'bg-danger-50 text-danger-700 ring-danger-700/15 border-danger-200/60',
    neutral: 'bg-neutral-100 text-neutral-700 ring-neutral-700/10 border-neutral-200/60',
    accent:  'bg-accent-50 text-accent-700 ring-accent-700/15 border-accent-200/60',
};

const Badge = ({ tone = 'neutral', children, dot = false, pulse = false, className = '' }) => (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 text-xs font-medium rounded-full border ring-1 ${TONE[tone] || TONE.neutral} ${className}`}>
        {dot && (
            <span className="relative flex h-1.5 w-1.5">
                {(pulse || tone === 'success') && (
                    <span className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${
                        tone === 'success' ? 'bg-success-400' :
                        tone === 'warning' ? 'bg-warning-400' :
                        tone === 'danger'  ? 'bg-danger-400' :
                        'bg-primary-400'
                    }`} />
                )}
                <span className={`relative inline-flex rounded-full h-1.5 w-1.5 ${
                    tone === 'success' ? 'bg-success-500' :
                    tone === 'warning' ? 'bg-warning-500' :
                    tone === 'danger'  ? 'bg-danger-500' :
                    tone === 'primary' ? 'bg-primary-500' :
                    'bg-neutral-400'
                }`} />
            </span>
        )}
        <span>{children}</span>
    </span>
);

export default Badge;
